/**
 * 💓 نبضة النشاط — «الموظف شغّال دلوقتي فعلًا؟»
 *
 * ⛔ **الشرط اللي بيخلّي الرقم يعني حاجة:** النبضة ما بتتبعتش إلا لو
 *    التبويبة **ظاهرة** و**فيها حركة فعلية** (ماوس · كيبورد · تمرير · لمس)
 *    في آخر دقيقة. التبويبة السايبة مفتوحة على الشاشة طول الليل بترجّع
 *    **صفر** — وده المقصود. لوحة بتقول ٨ ساعات على تبويبة نايمة أسوأ من
 *    مفيش لوحة، لأن الناس بتاخد قرارات بيها.
 *
 * 🔒 **مفيش أي محتوى بيتبعت** — لا صور شاشة، ولا اللي اتكتب، ولا الصفحة
 *    اللي مفتوحة. الطلب **جسمه فاضي** حرفيًا، والسيرفر بياخد ساعته هو
 *    ويسجّل دقيقة. حتى لو حد عبث بالكود، أقصى حاجة يقولها «كنت هنا».
 */
import { api } from "@/api/client";

const PULSE_EVERY_MS = 60_000;
/** الحركة لازم تكون في آخر دقيقة — نفس طول الدورة */
const IDLE_AFTER_MS = 60_000;

let timer: number | null = null;
let lastInteraction = 0;

const ACTIVITY_EVENTS = [
  "mousedown",
  "keydown",
  "scroll",
  "touchstart",
  "pointermove",
] as const;

function markInteraction() {
  lastInteraction = Date.now();
}

async function sendPulse() {
  // التبويبة مخفية ⇒ مش شغل مهما كانت الحركة
  if (document.visibilityState !== "visible") return;
  if (Date.now() - lastInteraction > IDLE_AFTER_MS) return;
  try {
    await api.post<{ day: string; active_minutes: number }>("/performance/pulse");
  } catch {
    // ⚠️ الصمت هنا **مقصود**: النبضة قياس مساعد مش شغل الموظف. لو الشبكة
    //    وقعت، ممنوع نطلّع رسالة خطأ توقّفه عن حاجة هو أصلًا مش طالبها.
    //    الدقيقة بتضيع، والشغل بيكمّل — ده الترتيب الصح للأولويات.
  }
}

/** بيشغّل النبض. بيرجّع دالة إيقاف. */
export function startPulse(): () => void {
  if (timer !== null) return stopPulse;
  markInteraction();
  for (const evt of ACTIVITY_EVENTS) {
    window.addEventListener(evt, markInteraction, { passive: true });
  }
  timer = window.setInterval(() => void sendPulse(), PULSE_EVERY_MS);
  return stopPulse;
}

export function stopPulse(): void {
  if (timer !== null) {
    window.clearInterval(timer);
    timer = null;
  }
  for (const evt of ACTIVITY_EVENTS) {
    window.removeEventListener(evt, markInteraction);
  }
}
